// useGetDocuments.ts
import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { PandaDocument } from 'types'

export const pandaAccessToken =
  import.meta.env.VITE_ENV === 'local'
    ? '44c682867cd90875b3ba53db7280c56e1a4d6068'
    : localStorage.getItem('panda_access_token') || ''

type PandaDocumentsApi = { results: PandaDocument[] }

const getDocuments = async (): Promise<PandaDocumentsApi> => {
  if (!pandaAccessToken) throw new Error('Missing/expired Panda token')
  const url = `${baseUrl}/aws/pandadoc/documents`
  const res = await axios.get<PandaDocumentsApi>(url, {
    headers: { Authorization: `Bearer ${pandaAccessToken}` },
  })
  return res.data
}

export const useGetDocuments = (queryKey = ['pandaDocuments']) => {
  const q = useQuery<PandaDocumentsApi, Error, PandaDocument[]>({
    queryKey,
    queryFn: getDocuments,
    staleTime: Infinity,
    enabled: Boolean(pandaAccessToken),
    // 🔽 This makes the hook return just PandaDocument[]
    select: data => data?.results ?? [],
  })

  return {
    data: q.data ?? [],
    isLoading: q.isLoading,
    isError: q.isError,
  }
}
